module.exports = __webpack_public_path__ + "assets/img/b95b-gn.svg";